type ClassValue = string | number | null | false | undefined | ClassValue[] | Record<string, boolean | null | undefined>;

function toVal(mix: ClassValue): string {
  let str = "";
  if (typeof mix === "string" || typeof mix === "number") {
    str += mix;
  } else if (Array.isArray(mix)) {
    for (let i = 0; i < mix.length; i++) {
      const y = toVal(mix[i]);
      if (y) {
        if (str) str += " ";
        str += y;
      }
    }
  } else if (mix && typeof mix === "object") {
    for (const key in mix) {
      if ((mix as Record<string, boolean | null | undefined>)[key]) {
        if (str) str += " ";
        str += key;
      }
    }
  }
  return str;
}

export function cn(...inputs: ClassValue[]): string {
  let str = "";
  for (let i = 0; i < inputs.length; i++) {
    const x = toVal(inputs[i]);
    if (x) {
      if (str) str += " ";
      str += x;
    }
  }
  return str;
}